import React, { useState } from 'react';

/**
 * Session-48j — Small centered dialog for optional Mark-as-Solved note.
 *
 * Renders when `open` is true. Keeps its own text state so parent doesn't
 * re-render every keystroke. onConfirm receives the trimmed note (empty
 * string means "no note").
 */
const MarkSolvedNoteModal = ({ open, onClose, onConfirm, busy }) => {
  const [note, setNote] = useState('');
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/50 z-[110] flex items-center justify-center p-4" onClick={() => !busy && onClose()}>
      <div onClick={(e) => e.stopPropagation()}
           className="bg-white rounded-xl w-full max-w-sm p-4 shadow-2xl"
           data-testid="mark-solved-note-modal">
        <h3 className="font-bold text-base mb-1">✅ Mark as Solved</h3>
        <p className="text-xs text-slate-500 mb-3">Add a note (optional) — will show in the Enquiry report.</p>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={3}
          maxLength={280}
          placeholder="e.g. Client converted, MB assigned"
          className="w-full px-3 py-2 border border-slate-300 rounded-md text-sm resize-none"
          data-testid="mark-solved-note-input"
        />
        <div className="flex gap-2 justify-end mt-3">
          <button
            disabled={busy}
            onClick={() => { setNote(''); onClose(); }}
            className="px-3 py-1.5 text-sm rounded border border-slate-300 hover:bg-slate-50 disabled:opacity-50"
            data-testid="mark-solved-cancel-btn"
          >Cancel</button>
          <button
            disabled={busy}
            onClick={() => { onConfirm(note.trim()); setNote(''); }}
            className="px-3 py-1.5 text-sm rounded bg-emerald-600 hover:bg-emerald-700 text-white font-bold disabled:opacity-50"
            data-testid="mark-solved-confirm-btn"
          >{busy ? 'Saving…' : 'Mark Solved'}</button>
        </div>
      </div>
    </div>
  );
};

export default MarkSolvedNoteModal;
